import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Injector, Input, NgModule, OnChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { ActivityEntityName, ActivityKind, Entity, WorkRole, WorkType } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'email-template-picker',
    templateUrl: './email.template.picker.component.html',
    styleUrls: ['./email.template.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: EmailTemplatePickerComponent, multi: true }
    ],
    standalone: false
})
export class EmailTemplatePickerComponent extends PickerBaseComponent implements OnChanges {

  @Input() public data: Entity[];
  @Input() public placeholder = '<Email Template>';
  @Input() public appendTo;
  @Input() public multiple: boolean;
  @Input() public entity: ActivityEntityName;
  @Input() public kind: ActivityKind;

  public data$: Observable<Entity[]>;
  public PickerItemStyle = PickerItemStyle;

  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
  }

  public ngOnChanges() {

    this.data$ = this.fetch === PickerFetch.Automatic
      ? this.getEmails(this.entity, this.kind)
      : of(this.data);

  }

  private getEmails(entity: ActivityEntityName, kind: ActivityKind): Observable<Entity[]> {
    return this.http.get<WorkRole[]>(`/api/picker/email/template/${entity}`, { params: { kind } });
  }
}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule
  ],
  declarations: [
    EmailTemplatePickerComponent
  ],
  providers: [],
  exports: [
    EmailTemplatePickerComponent
  ],
})
export class EmailTemplatePickerModule { }
